module.exports = __webpack_public_path__ + "img/r-58.7c3f3a13.jpg";